import { Period, PeriodType } from '../Period';
import { II18n } from '../useTranslation';

const NS = 'periodFormat';

export function formatPeriod(i18n: II18n, value: Period) {
  switch (value.periodType) {
    case PeriodType.CALENDAR_MONTH:
      return i18n.t('period.financialMonth', { year: value.year, month: value.periodNumber, ns: NS });
    case PeriodType.FINANCIAL_MONTH:
      return i18n.t('period.calendarMonth', { year: value.year, month: value.periodNumber, ns: NS });
    case PeriodType.CALENDAR_QUARTER:
      return i18n.t('period.financialQuarter', { year: value.year, quarter: value.periodNumber, ns: NS });
    case PeriodType.FINANCIAL_QUARTER:
      return i18n.t('period.calendarQuarter', { year: value.year, quarter: value.periodNumber, ns: NS });
    case PeriodType.CALENDAR_YEAR:
      return i18n.t('period.calendarYear', { year: value.year, ns: NS });
    case PeriodType.FINANCIAL_YEAR:
      return i18n.t('period.financialYear', { year: value.year, ns: NS });
    default:
      if (process.env.NODE_ENV !== 'production') {
        throw new Error(`Unknown period type [${value.periodType}]`);
      }
      console.warn('Unknown period type', value.periodType);

      return '';
  }
}
